module.exports = __webpack_public_path__ + "img/NowThis.4ba98362.png";